import * as moment from 'moment';
import { Moment } from 'moment';

export default class ProjectChildComment {
  id?: number;
  body: string;
  authorId?: number;
  authorName?: string;
  parentCommentId: number;
  createdAt?: Moment;

  constructor(entity: ProjectChildComment) {
    this.id = entity.id || undefined;
    this.body = entity.body;
    this.authorId = entity.authorId || undefined;
    this.authorName = entity.authorName || undefined;
    this.parentCommentId = entity.parentCommentId;
    this.createdAt = moment(entity.createdAt) || undefined;
  }
}



// WEBPACK FOOTER //
// ./src/entities/ProjectChildComment.tsx